module.exports = __webpack_public_path__ + "img/truvalidate-logo.6e5e155a.png";